module.exports = __webpack_public_path__ + "static/Group 6760-9303de7c1f60f3ff3cd5e2d805921230.png";